export default __webpack_public_path__ + "static/media/icon-WBTC.202cce58.svg";